import React, { useState, useEffect } from 'react';
import CenTable from './CenTable';
import { Auth } from 'aws-amplify';
import { user } from '../lib/authLib';
import config from '../config';
export default function People() {
  useEffect(() => {
    getPeopleData();
  }, []);
  const [people, setPeople] = useState([]);
  const columns = [
    {
      title: 'Email',
      key: 'email',
      sort: true,
      editable: false,
      filter: true,
      print: true,
      sum: false,
    },
    {
      title: 'Name',
      key: 'name',
      sort: true,
      editable: false,
      filter: true,
      print: true,
      sum: false,
    },
    {
      title: 'Role',
      key: 'role',
      filter: true,
      editable: true,
      sort: true,
      print: true,
      sum: false,
    },
  ];

  async function getPeopleData() {
    const currentUserSession = await Auth.currentSession();
    const result = await window.fetch(`${config.serverUrl}users/allusers/${user[0].email}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'accesstoken': currentUserSession.getAccessToken().getJwtToken(),
      },
    });
    setPeople(await result.json());
  }

  return (
    <div>
      <CenTable
        title="People"
        columns={columns}
        dataSource={people}
        onSave={async (x, y) => {
          const currentUserSession = await Auth.currentSession();
          for (let i = 0; i < x.length; ++i) {
            if (x[i].role !== y[i].role) {
              await window.fetch(`${config.serverUrl}users/update_role/${user[0].email}/${y[i].email}/${y[i].role}`, {
                method: 'get',
                headers: {
                  'Content-Type': 'application/json',
                  'accesstoken': currentUserSession.getAccessToken().getJwtToken(),
                },
              });
            }
          }
        }}
      />
    </div>
  );
}
